import type { ReactElement } from 'react';
import { SiteFooterBrand } from './site-footer-brand';

/**
 * 사이트 푸터 — 모든 고객 화면(HOME 포함)이 같은 흑연 브랜드 푸터를 쓴다.
 * 흰 로고·약관 링크·사업자 정보·고객센터 번호는 SiteFooterBrand 가 그린다.
 */
export const SiteFooter = (): ReactElement => <SiteFooterBrand />;
